/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Round_Mean_Owl_PersistInputs */

const fr_round_mean_owl_persist = /** @type {(inputs: Round_Mean_Owl_PersistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible dans l'application`)
};

/**

* @param {Round_Mean_Owl_PersistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const round_mean_owl_persist = /** @type {((inputs?: Round_Mean_Owl_PersistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Round_Mean_Owl_PersistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_round_mean_owl_persist(inputs)
});